import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DateTime } from 'luxon';
import { IEvent } from './Carousel';
import EventImage from './EventImage';
import './style/eventModal.css';


interface IEventModalProps {
    event: IEvent;
}


function EventModal( props: IEventModalProps ) {

	const navigate = useNavigate();

	return (
		<div className='modal-container' > 
		<div className='modal-shadow-layer'
			onClick={() => {
				navigate(-1);
			}}
		></div>
		<div key="event-modal" className="event-modal night-palette-6-bg">
			<div className="event-modal-image">
				<EventImage src={props.event.img_url} checkSize={props.event.url.includes("songkick")} />
			</div>
			<div className="event-modal-location">At {props.event.location},</div>
			<div className="event-modal-name">{props.event.name}</div>
			<div className="event-date">{ DateTime.fromISO(props.event.date).toFormat('EEEE dd LLL yyyy') }</div>
			<div className="event-link">
				<a href={props.event.url} target='_blank' rel="noreferrer">Find out more</a>
			</div>
		</div>
		</div>
	)
}


export {
    EventModal
}